import { hotRank } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

const trendIcon: Record<string, { cls: string; icon: string }> = {
  up: { cls: "text-brand-500", icon: "ri-arrow-up-line" },
  down: { cls: "text-stone-400", icon: "ri-arrow-down-line" },
  new: { cls: "text-gold-600", icon: "ri-sparkling-2-fill" },
};

const tagCls: Record<string, string> = {
  热: "bg-brand-500 text-white",
  新: "bg-gold-500 text-[#241b13]",
  缓: "bg-stone-200 text-stone-600",
};

export default function HotRank() {
  return (
    <section id="hot" className="relative scroll-mt-24 bg-white py-10 md:py-14">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="lg:sticky lg:top-28">
            <SectionHead
              kicker="今日热点榜单"
              title="此刻全网最烫的十个瓜"
              desc="热度综合浏览量、讨论量与编辑部加权得出，每 15 分钟刷新一次。榜上即热点，点开别错过。"
              align="left"
            />
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-stone-200 bg-stone-50 px-3 py-1.5 text-[12px] text-stone-500">
              <i className="ri-time-line text-stone-400" />
              榜单更新于 今天 12:45
            </div>
            <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-stone-400">
              <i className="ri-lightbulb-flash-line mr-1 text-gold-500" />
              小贴士：热度每分钟都在变。想第一时间知道谁上位，记得把「刷新越快、料越足」变成肌肉记忆。
            </p>
          </div>
        </div>

        <ol className="flex flex-col gap-3 lg:col-span-3">
          {hotRank.map((it) => {
            const trend = trendIcon[it.trend] || trendIcon.down;
            const top3 = it.rank <= 3;
            return (
              <li key={it.rank}>
                <button
                  className="group flex w-full items-center gap-3 rounded-2xl border border-stone-200 bg-white px-4 py-3.5 text-left transition-colors hover:border-gold-200 hover:bg-gold-50/50"
                  onClick={() => {
                    const el = document.getElementById("headlines");
                    el?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  <span
                    className={
                      "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-heading text-[16px] font-black " +
                      (top3 ? "bg-brand-500 text-white" : "bg-stone-100 text-stone-400 group-hover:bg-brand-100 group-hover:text-brand-700")
                    }
                  >
                    {String(it.rank).padStart(2, "0")}
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate text-[15px] font-semibold text-[#241b13] group-hover:text-brand-700">
                      {it.title}
                    </span>
                    <span className="mt-1 flex items-center gap-2">
                      <span className={(tagCls[it.tag] || "bg-stone-100 text-stone-600") + " rounded px-1.5 py-px text-[10px] font-bold"}>
                        {it.tag}
                      </span>
                      <span className="h-1.5 w-24 overflow-hidden rounded-full bg-stone-100">
                        <span
                          className={"block h-full rounded-full " + (top3 ? "bg-brand-500" : "bg-gold-400")}
                          style={{ width: `${Math.min(100, it.score)}%` }}
                        />
                      </span>
                    </span>
                  </span>
                  <span className="flex shrink-0 flex-col items-end gap-1">
                    <span className="font-heading text-[15px] font-black text-[#241b13]">{it.score}</span>
                    <span className="inline-flex items-center gap-1 text-[11px] text-stone-400">
                      <i className={"text-[13px] " + trend.cls + " " + trend.icon} />
                      {it.trend === "new" ? "新上榜" : it.trend === "up" ? "上升" : "降温"}
                    </span>
                  </span>
                </button>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}